module.exports = __webpack_public_path__ + "static/media/25UNHCR3.5e991ea3.jpg";